import { useEntities } from "@hooks/useEntities";
import React, { useContext } from "react";
import { useEffectiveBookkeepingStartDate } from "@hooks/useEffectiveBookkeepingStartDate";
import { NoMatchingTransactions } from "./NoMatchingTransactions";
import { NoTransactions } from "./NoTransactions";
import {
    PaginatedTransactionsActionsContext,
    PaginatedTransactionsDataContext,
} from "./PaginatedTransactionsTable.context";
import "./TransactionsPage.scss";
import { useFiltersActive } from "./useFiltersActive";

export const TransactionsPageEmptyState: React.FC = () => {
    const { filters: currentFilters } = useContext(
        PaginatedTransactionsDataContext,
    );
    const { setCurrentFilters } = useContext(
        PaginatedTransactionsActionsContext,
    );
    const filtersActive = useFiltersActive(currentFilters);
    const bookkeepingStartDate = useEffectiveBookkeepingStartDate(
        currentFilters.entityIds,
    );
    const entities = useEntities();
    const entityIds = entities.map((entity) => entity.id);

    if (filtersActive) {
        return (
            <NoMatchingTransactions
                onResetFilters={() =>
                    setCurrentFilters({
                        entityIds,
                    })
                }
                bookkeepingStartDate={bookkeepingStartDate}
            />
        );
    }

    return <NoTransactions />;
};
